import axios from "axios"
import appConfig from "../../configs/appConfig";
import {parseKendoGridDataState} from "../components/utils";

const comunicationPath = appConfig.API.comunications
const hazardReportPath = appConfig.API.hazard_reports


const getComunications = async (
	translateHook,
	i18n,
	dataState,
	exportScope = false,
	cancelDataToken = undefined,
	to_read = null
) => {

	let parseDataState,
        response_comunication,
		comunications
    if (exportScope)
		parseDataState = parseKendoGridDataState(dataState, '?skip=0')
	 else
        parseDataState = parseKendoGridDataState(dataState)

	if (to_read !== null)
		parseDataState += `&to_read=${to_read}`

	try {
		response_comunication = await axios.get(comunicationPath + parseDataState, cancelDataToken ? cancelDataToken : {})
		comunications = response_comunication.data.results
		return Promise.resolve({
			comunications,
			count: response_comunication.data.count
		})
	} catch (e) {
		return Promise.reject(new Error(`Exception Fetching comunication from API ${e}`))
	}
}

const getComunication = async (comunicationId) => {
	return axios.get(`${comunicationPath}/${comunicationId}`)
}

const updateComunication = async (comunicationId, data) => {
	return axios.put(`${comunicationPath}/${comunicationId}`, data)
}

const createComunication = async (data) => {
	return axios.post(`${comunicationPath}`, data)
}

const deleteComunication = async (comunicationId) => {
	return axios.delete(`${comunicationPath}/${comunicationId}`)
}

const submitComunicationToIride = async (comunicationId) => {
	return axios.post(`${hazardReportPath}/${comunicationId}/submit_to_iride`)
}

export {
	getComunication,
	getComunications,
	updateComunication,
	deleteComunication,
	createComunication,
	submitComunicationToIride
}